export const baseUnits = [
	{ value: 1, label: "g - cc" },
	{ value: 1000, label: "Kg - L" },
	{ value: 10000, label: "Tn - KL" },
];

export const baseFilterOrders = {
	page: 1,
	paginate: 10,
	order: "dealer_number",
	orderType: "desc",
	defaultUnitFilter: 1000,
	purchaseOrderSaleFilter: "",
	dateFilter: "",
	dateToFilter: "",
};

export const table_head = [
	{
		name: "Razón Social",
		size: "10",
		order: "business_name",
	},
	{
		name: "Fecha Ingreso",
		size: "10",
		order: "created_date",
	},
	{
		name: "Distribuidor",
		size: "10",
		order: "dealer_name",
	},
	{
		name: "N° Factura",
		size: "10",
		order: "dealer_number",
	},
	{
		name: "OC Asociadas",
		size: "10",
		order: "",
	},
	{
		name: "%Recepción",
		size: "8",
		order: "",
	},
	{
		name: "Fecha Emisión",
		size: "10",
		order: "date_orders_sale",
	},
	{
		name: "Cantidad Envases",
		size: "8",
		order: "created_date",
	},
	{
		name: "Costo Total",
		size: "10",
		order: "created_date",
	},

	{
		name: "Acción",
		size: "4",
		order: "",
	},
	{
		name: "",
		size: "2",
		order: "",
	},
];
